import React from 'react';
import { Link } from '@compat/router';
import ErrorPagesWrapper from '../components/ErrorPagesWrapper';

const NotFound404 = () => (
  <ErrorPagesWrapper type='404'>
    <div className='main-container error-container error-404-bg'>
      <div className='code'>404</div>
      <h1 className='description'>Эта страница не найдена :{'('}</h1>
      <div className='info'>
        Не расстраивайтесь! Все, что нужно,
        <br /> найдётся в нашем каталоге
      </div>
      <Link to='/catalog'>
        <button className='button-green'> Перейти в каталог </button>
      </Link>
    </div>
  </ErrorPagesWrapper>
);

export default NotFound404;
